import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function PageLoader({ label = "Loading" }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-slate-500" data-testid="page-loader">
      <Loader2 className="w-6 h-6 animate-spin text-[#006090]" />
      <p className="mt-3 text-sm">{label}…</p>
    </div>
  );
}

export function InlineSpinner({ className }) {
  return <Loader2 className={cn("w-4 h-4 animate-spin", className)} />;
}
